import React, { useEffect } from 'react';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import dayjs from 'dayjs';
import { Typography, Box } from '@mui/material';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './configEditor/styleEditor.css';
import editorToolbar from './configEditor/editorToolbar';
import './styleEditor.css';

function HtmlEditorEmail({
  content,
  validContent,
  setContent,
  editeState,
  setEditeState,
}) {
  const handleEditorStateChange = (editorState) => {
    setEditeState(editorState);
  };

  const handleContentStateChange = (contentState) => {
    setContent(draftToHtml(contentState));
  };

  const getSampleContent = (html) => {
    if (!html) return '';
    return html
      .replace(/\n/g, '<br/>')
      .replace(/\${invoice_no}/g, `INV-${dayjs().format('YYYYMMDD')}`)
      .replace(/\${so_name}/g, 'ผู้ใช้บริการ')
      .replace(
        /\${link_payment}/g,
        `<a href="https://example.com" 
              style="color: blue; text-decoration: underline;" 
              target="_blank">
              https://example.com
          </a>`,
      )
      .replace(
        /\${qr_payment}/g,
        `<img src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://example.com" 
              alt="QR Code" 
              style="width: 100px; height: 100px; display: block; margin: 10px 0;" />`,
      );
  };

  function isValidate(Content) {
    switch (Content) {
      case true:
        return {
          border: '2px solid #ff0000ec',
          borderRadius: '3px',
        };
      case false:
        return {
          border: '1px solid #6666665c',
          borderRadius: '3px',
        };
      default:
        return {};
    }
  }

  useEffect(() => {
    if (editeState) {
      const rawContentState = convertToRaw(editeState.getCurrentContent());
      const htmlContent = draftToHtml(rawContentState);
      setContent(htmlContent);
    }
  }, [editeState]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        width: '100%',
      }}
    >
      <Editor
        editorState={editeState}
        toolbarClassName="editor-toolbar"
        wrapperClassName="editor-wrapper"
        editorClassName={validContent ? 'editorError' : 'editor'}
        toolbarStyle={isValidate(validContent)}
        onEditorStateChange={handleEditorStateChange}
        onContentStateChange={handleContentStateChange}
        toolbar={editorToolbar}
      />
      {validContent && (
        <Typography
          sx={{ fontSize: '12px', marginTop: '7px', marginLeft: '15px' }}
          color="error"
        >
          กรุณากรอกข้อมูลแบบฟอร์ม
        </Typography>
      )}
      <h3>ตัวอย่างอีเมลที่ลูกหนี้จะได้รับ</h3>
      <div
        dangerouslySetInnerHTML={{ __html: getSampleContent(content) }}
        style={{
          border: '1px solid #ddd',
          padding: '10px',
          minHeight: '150px',
          fontSize: '14px',
        }}
      />
    </Box>
  );
}

export default HtmlEditorEmail;
